<div class="noAccessStubClass">
  <div class="no-access-stub-block">
    <span class="font-icons icon-no_access"></span>
    <span *ngIf="text" class="text" [innerHTML]="text"></span>
  </div>
</div>
